export default __webpack_public_path__ + "static/media/upload-img1.9e453f59.png";